export const sylvesterNumbers = [
  2,
  6,
  42,
  1806,
  3263442,
  10650056950806,
]
